import React from 'react';
import { getRsvpUnitIcon } from '../utils/getRsvpUnitIcon';
import { getRsvpUnitSubtitle } from '../utils/getRsvpUnitSubtitle';
import { getRsvpUnitTitle } from '../utils/getRsvpUnitTitle';
import { HubItem } from 'mini-hub';
import { HubItemStyleProps } from 'mini-hub/lib/components/HubItem.types';
import { RsvpBarIcon } from './RsvpBarIcon';
import { RsvpUnitProps } from '../schema/RsvpUnit.types';

const styles = require('./RsvpUnit.scss');

const RsvpInfoBar: React.FC<RsvpUnitProps> = props => {
    const { item, originalMeetingMessage } = props;

    if (!item) {
        return null;
    }

    // get all the icon details
    const { iconContainerStyles } = getRsvpUnitIcon(item);

    const onRenderIcon = () => <RsvpBarIcon item={item} />;

    const title = getRsvpUnitTitle(item);
    const subtitle = getRsvpUnitSubtitle(item, originalMeetingMessage);

    const unitStyles: HubItemStyleProps = {
        className: styles.container,
        primaryTextStyles: styles.unitTextContainer,
        secondaryTextStyles: styles.unitTextContainer,
        iconContainerStyles,
    };

    return (
        <>
            <HubItem
                styles={unitStyles}
                onRenderIcon={onRenderIcon}
                primaryText={title}
                secondaryText={subtitle}
                isHubItemNotTabbable
            />
        </>
    );
};

export default RsvpInfoBar;
